/* New script start */
document.addEventListener('DOMContentLoaded', function () {
  const selectedGrid = document.getElementById('selected-products-grid');
  const slots = Array.from(selectedGrid.querySelectorAll('.mix_item'));
  const addAllBtn = document.getElementById('mix_main_product');
  const selectedItems = []; // keeps order aligned with slots
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function updateSlots() {
    slots.forEach((slot, index) => {
      const imgWrap = slot.querySelector('.mix__item_blockimg');
      const info = slot.querySelector('.mix_info');
      const product = selectedItems[index];

      if (product) {
        imgWrap.innerHTML = `
          <div class="product-image-wrapper">
            <img src="${product.image}" alt="" loading="lazy">
            <button class="remove-product" data-index="${index}" aria-label="Remove"><img src="https://cdn.shopify.com/s/files/1/2135/4367/files/Group_77.png?v=1767422362"/></button>
          </div>
        `;
        info.textContent = formatMoney(Math.round(product.price / 100) * 100).replace(/\.00$/, '');
        slot.classList.add('active-slot');
      } else {
        imgWrap.innerHTML = '';
        info.textContent = '';
        slot.classList.remove('active-slot');
      }
    });

    addAllBtn.disabled = selectedItems.length === 0;
  }
  function applyBundleDiscount(selectedItems) {
  let baseTotal = 0;
  selectedItems.forEach(item => {
    if (!item) return;
    baseTotal += item.originalPrice;
  });
  //const discountRate = baseTotal >= 10000 ? 0.11 : 0;
  selectedItems.forEach(item => {
    if (!item) return;
    item.price = Math.round(item.originalPrice);
  });
}
 function updateBundlePrice(selectedItems) {
  const saleEls = document.querySelectorAll('#bundle-price .sale-price');
  const compareEls = document.querySelectorAll('#bundle-price .regular-price');

  let saleTotal = 0;
  let regularTotal = 0;
  const DISCOUNT_PERCENT = 20.1;

  selectedItems.forEach(item => {
    if (!item) return;
    const discountedPrice = Math.round(item.comparePrice * 0.79915);
    
    saleTotal += discountedPrice;
    regularTotal += item.comparePrice && item.comparePrice > item.price
      ? item.comparePrice
      : item.price;
  });

  const formattedPrice = formatMoney(saleTotal).replace(/\.00$/, '');
  const formattedCompare = formatMoney(regularTotal).replace(/\.00$/, '');

  // ✅ Update BOTH mobile & desktop
  saleEls.forEach(el => {
    el.textContent = formattedPrice;
  });
  compareEls.forEach(el => {
    if (regularTotal > saleTotal) {
      el.textContent = formattedCompare;
      el.style.display = 'inline';
    } else {
      el.style.display = 'none';
    }
  });
}
const BUNDLE_THRESHOLD = 10000;
function updateCartTrackerMessage(selectedItems) {
  const messageEl = document.querySelector('.cart-tracker-message');
  const messageElDesk = document.querySelector('.cart-tracker-message-desk');
  const wrapperEl = document.querySelector('.cart-trackert-and-gift');
  const addtoCartBtn = document.querySelector('.mix_main_product');

  const beforeImg = document.querySelector('.before-thredsold-rich');
  const afterImg = document.querySelector('.after-thredsold-rich');
  if (!messageEl) return;

  let subtotal = 0;

  selectedItems.forEach(item => {
    if (!item) return;
    subtotal += item.originalPrice;
  });
  if (!wrapperEl) return;

  if (subtotal >= BUNDLE_THRESHOLD) {
    beforeImg && (beforeImg.style.display = 'none');
    afterImg && (afterImg.style.display = 'block');
    wrapperEl.classList.add('active');
    addtoCartBtn.classList.remove('disabled');
    messageEl.textContent = "You’ve Unlocked 20% Off + Exclusive Gifts";
    messageElDesk.textContent = "You’ve Unlocked 20% Off + Exclusive Gifts";
    messageEl.classList.add('cart-success-message');
    messageElDesk.classList.add('cart-success-message');
  } else {
    beforeImg && (beforeImg.style.display = 'block');
    afterImg && (afterImg.style.display = 'none');
    wrapperEl.classList.remove('active');
    addtoCartBtn.classList.add('disabled');
    const remaining = BUNDLE_THRESHOLD - subtotal;
    messageEl.innerHTML = `Add <span class="subtotal-price">${formatMoney(remaining)}</span> to Unlock 20% Off + Exclusive Gifts`;
    messageElDesk.innerHTML = `Add <span class="subtotal-price">${formatMoney(remaining)}</span> to Unlock 20% Off + Free Shipping + Exclusive Gifts`;
    messageEl.classList.remove('cart-success-message');
    messageElDesk.classList.remove('cart-success-message');
  }
}

function updateBundleProgress(selectedItems) {
  const bar = document.querySelector('.bundle-progress__bar');
  const text = document.querySelector('.bundle-progress__text');
  if (!bar || !text) return;

  let subtotal = 0;

  selectedItems.forEach(item => {
    if (!item) return;
    subtotal += item.originalPrice;
  });

  const progress = Math.min((subtotal / BUNDLE_THRESHOLD) * 100, 100);

  bar.style.width = `${progress}%`;

  if (subtotal >= BUNDLE_THRESHOLD) {
    bar.classList.remove('is-blue');
    bar.classList.add('is-green');
  } else {
    bar.classList.remove('is-green');
    bar.classList.add('is-blue');
  }
}

const discountCode = '20OFFSUB';

function applyBundleDiscountCode(){
  fetch("/discount/"+discountCode).then(function(){
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0}));
    //$(".cart_dr")[0].click();
  });
}
applyBundleDiscountCode();

  function getNextEmptyIndex() {
    return selectedItems.findIndex(item => item === null);
  }
  for (let i = 0; i < slots.length; i++) {
    selectedItems.push(null);
  }

  // ADD PRODUCT
  document.querySelectorAll('.add-to-protocol').forEach(btn => {
    btn.addEventListener('click', () => {

      const variantId = btn.dataset.variantId;
      const price = parseInt(btn.dataset.price, 10);
      const comparePrice = parseInt(btn.dataset.comparePrice, 10);
      const sellingPlan = btn.dataset.sellingPlan;
      const image = btn.dataset.image;

      const emptyIndex = getNextEmptyIndex();
      if (emptyIndex === -1) return;

      selectedItems[emptyIndex] = {
        id: variantId,
        quantity: 1,
        originalPrice: price, 
        price,
        comparePrice: comparePrice,
        selling_plan: sellingPlan,
        image
      };

      applyBundleDiscount(selectedItems);
       updateSlots();
      updateBundlePrice(selectedItems);
      updateCartTrackerMessage(selectedItems);
      updateBundleProgress(selectedItems);
    });
  });

  // REMOVE PRODUCT (event delegation)
  selectedGrid.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('.remove-product');
  if (!removeBtn) return;

  const index = parseInt(removeBtn.dataset.index, 10);
  selectedItems.splice(index, 1);
  const MAX_SLOTS = 6;
  while (selectedItems.length < MAX_SLOTS) {
    selectedItems.push(null);
  }
  applyBundleDiscount(selectedItems);
  updateSlots();
  updateBundlePrice(selectedItems);
  updateCartTrackerMessage(selectedItems);
  updateBundleProgress(selectedItems);
});

  addAllBtn.addEventListener('click', () => {
  const items = selectedItems
    .filter(Boolean)
    .map(({ id, quantity, selling_plan }) => ({
      id,
      quantity,
      selling_plan,
      properties: { '_subscription_bundle': 'true' }
    }));
    items.push(
      {
        id: 42609635852386,
        quantity: 1
      }
    );
  if (!items.length) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items
    })
  }).then(() => {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
    setTimeout(function(){
     applyBundleDiscountCode();
    }, 700);
    $('.cart_dr')[0].click();
   
  });
});
});
document.addEventListener('DOMContentLoaded', function () {
  if(window.innerWidth < 1007){
  const trigger = document.querySelector('.pre-cart-top-area');
  const tracker = document.querySelector('.cart-trackert-and-gift');
  const grid = document.querySelector('#selected-products-grid');
  const arrow = document.querySelector('.toggle-arrow-image');
    function openSection() {
      console.log('open');
    tracker.style.display = 'flex';
    grid.style.display = 'flex';
    arrow?.classList.add('is-open');
  }
  function openBundlePopupMobile() {
  const tracker = document.querySelector('.cart-trackert-and-gift');
  const grid = document.querySelector('#selected-products-grid');
  const arrow = document.querySelector('.toggle-arrow-image');

  if (!tracker || !grid) return;

  tracker.style.display = 'flex';
  grid.style.display = 'flex';
  arrow?.classList.add('is-open');
}
  function closeSection() {
    console.log('close');
    tracker.style.display = 'none';
    grid.style.display = 'none';
    arrow?.classList.remove('is-open');
  }
  const bundleSection = document.querySelector('.tiered-bundle-discount');
const sentinel = bundleSection?.querySelector('.bundle-observer-sentinel');

if (!sentinel) {
  console.warn('Sentinel not found');
  return;
}
  const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      console.log('Intersecting:', entry.isIntersecting);

     if (tracker?.dataset.locked === 'true') return;

if (entry.isIntersecting) {
  openSection();
} else {
  closeSection();
}

    });
  },
  {
    root: null,          // viewport
    threshold: 0,
    rootMargin: '-40% 0px -40% 0px'
  }
);

observer.observe(sentinel);
  }

/* Sort by filter */
const bestSellers = [
  "7356379332706",
  "7464898658402",
  "1709897678946",
  "6650366263394",
  "7249778737250",
  "4372074791010",
  "4372069908578",
  "4506776109154",
  "6946124693602",
  "6922667098210",
  "6914006483042",
  "6807581425762"
];
function markBestSellers() {
  document.querySelectorAll('.rb-item').forEach(item => {
    const productId = item.getAttribute('data-rb-item-id');
    if (bestSellers.includes(productId)) {
      item.setAttribute('data-bestseller', 'true');
    }
  });
}
markBestSellers();

let originalOrder = [];

function captureOriginalOrder() {
   const grid = document.querySelector('.rb-items-wrapper');
  if (!grid) return;
  if (originalOrder.length === 0) {
    const items = Array.from(grid.querySelectorAll('.rb-item'));
    originalOrder = items.map((item, index) => {
      item.setAttribute('data-original-index', index); // store index
      return item;
    });
  }
}

function setupBenefitFilters() {
  const allProductsBtn = document.querySelector('#all-products-filter-btn');
  const bestSellerBtn = document.querySelector('#best-seller-filter-btn');
  const benefitButtons = document.querySelectorAll(
    '#radiant-skin, #immune-support, #gut-health, #energy'
  );

  function clearActive() {
    document
      .querySelectorAll('.catagory-filters .Button')
      .forEach(btn => btn.classList.remove('active'));
  }

  function restoreOriginalOrder() {
    const grid = document.querySelector('.rb-items-wrapper');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.rb-item'));
    items
      .sort(
        (a, b) =>
          parseInt(a.dataset.originalIndex) -
          parseInt(b.dataset.originalIndex)
      )
      .forEach(item => grid.appendChild(item));
  }

  benefitButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const selectedTag = btn.id.replace(/-/g, ' ').toLowerCase();

      document.querySelectorAll('.rb-item').forEach(item => {
        const productTags = Array.from(
          item.querySelectorAll('.ProductFilter_Tag li')
        ).map(tag =>
          tag.textContent.trim().toLowerCase()
        );

        item.style.display = productTags.includes(selectedTag)
          ? ''
          : 'none';
      });

      clearActive();
      btn.classList.add('active');
    });
  });

  if (bestSellerBtn) {
    bestSellerBtn.addEventListener('click', () => {
      document.querySelectorAll('.rb-item').forEach(item => {
        if (item.getAttribute('data-bestseller') === 'true') {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
      clearActive();
      bestSellerBtn.classList.add('active');
    });
  }
  // ✅ All Products → reset filters + order
  if (allProductsBtn) {
    allProductsBtn.addEventListener('click', () => {
      document.querySelectorAll('.rb-item').forEach(item => {
        item.style.display = '';
      });

      restoreOriginalOrder();
      clearActive();
      allProductsBtn.classList.add('active');
    });
  }
}
 captureOriginalOrder();
  setupBenefitFilters();
})

!function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){t.exports=n(1)},function(t,e,n){"use strict";function r(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e4;return new Promise((function(n){var r=setInterval((function(){t()&&(n(t()),clearInterval(r),r=null)}),500);setTimeout((function(){null!==r&&(clearInterval(r),console.log("condition false"))}),e)}))}n.r(e);var o={subCollections:".build-your-own-subscription",productItem:".CollectionList--Section .ProductList .ProductItem ",productWrapperRating:".Product__Wrapper .ProductItem__Rating",productItemAddToCartBtn:".ProductItem_AddToCartBtn .add-to-protocol",productGalleryCarouselImage:".Product__Gallery .Product__Slideshow.Carousel .AspectRatio--withFallback > img"},c={productPopupWrapper:"\n        <div class='pt354_popupWrapper'>\n        <div class='pt354_popupOverlay'></div>\n        <div class='pt354_popupContainer'>\n        <div class='pt354_closePopup'>\n        <div class='pt354_closePopup_btn'><img src='https://cdn.shopify.com/s/files/1/2135/4367/files/popup-close.png?v=1769414434' alt='popup close'/></div>\n        </div>\n        </div></div>",productPopup:"\n        <div class='pt354_popup'>\n        <div class='pt354_imageContainer'></div>\n        <div class='pt354_productDetailContainer'>\n        <p class='pt354_productName'></p>\n        <div class='pt354_reviewSection'></div>\n        <div class='pt354_productBenefitsContainer'></div>\n        <div class='pt354_productDetailDescriptionContainer'></div>\n        <div class='pt354_productPrice'></div>\n        <button class='pt354_addToCart_button'>ADD TO PROTOCOL</button>\n        <a class='pt354_productDescription'></a>\n        </div>\n        </div>\n        "};n(2),n(6);function i(){$(".pt354_popupWrapper .pt354_popupContainer .pt354_imageContainer > div").flickity({cellAlign:"left",contain:!0,autoPlay:!1,wrapAround:!0,prevNextButtons:!0,pageDots:!0})}var u=function(){!function(t,e){if(document.querySelector('script[src="'.concat(t,'"]')))e&&e();else{var n=document.createElement("script");n.src=t,n.onload=e,document.body.appendChild(n)}}("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js",i)};function p(t,e,n){window.dataLayer=window.dataLayer||[],window.dataLayer.push({event:"Convert_Test_Tracking",category:t,action:e,label:n})}function a(t){window._conv_q=window._conv_q||[],_conv_q.push(["triggerConversion",t])}function d(){var t=document.querySelector(".pt354_popupContainer");t&&t.querySelectorAll(".pt354_popup").forEach(function(t){t.remove()}),document.body.classList.remove("pt354_popupActive"),document.body.classList.remove("pt354_popupActive")}function l(t){var e=t.target.getAttribute("data-var_id");document.querySelector("button.add-to-protocol[data-variant-id='".concat(e,"']")).click(),d()}function s(t){var e,n,i=function(t){return{productLink:t.querySelector(".ProductItem__Wrapper > a").href,productName:t.querySelector("h2.ProductItem__Title.Heading").textContent.trim(),productPrice:t.querySelector(".ProductItem__PriceList.Heading").innerHTML,productId:t.querySelector(o.productItemAddToCartBtn).getAttribute("data-variant-id")}}(t),s=i.productLink,v=i.productName,_=i.productPrice,f=i.productId;e=".ProductLayout__New",n=function(e){var n=e.querySelector(o.productWrapperRating).outerHTML,i=e.querySelector(".ProductMeta__Tags").outerHTML,m=e.querySelector(".ProductMeta__Description ul").outerHTML,y=function(t){var e=t.querySelectorAll(o.productGalleryCarouselImage),n=document.createElement("div");return e.forEach((function(t){n.insertAdjacentElement("beforeend",t.cloneNode())})),n}(e);!function(t){var e,n=t.ele,r=t.productName,o=t.productPrice,i=t.productReview,u=t.productBenefits,p=t.productLink,a=t.imageWrapper,d=t.productId,l=t.productDescription,s=document.createElement("div");s.classList.add("pt354_product_popupWrapper"),s.innerHTML=c.productPopup,n.insertAdjacentElement("beforeend",s),s.querySelector(".pt354_productName").innerHTML=r,s.querySelector(".pt354_productPrice").innerHTML=o,s.querySelector(".pt354_reviewSection").innerHTML=i,s.querySelector(".pt354_productBenefitsContainer").innerHTML=u,s.querySelector(".pt354_productDetailDescriptionContainer").innerHTML=l,s.querySelector(".pt354_productDescription").href=(!1===(e=p).includes("?")?e+="?":e+="&",e+="ref=subs_lp_pdp_modal"),s.querySelector(".pt354_imageContainer").insertAdjacentElement("afterbegin",a),s.querySelector(".pt354_addToCart_button").setAttribute("data-var_id",d)}({ele:t,productName:v,productPrice:_,productReview:n,productBenefits:i,productLink:s,imageWrapper:y,productId:f,productDescription:m}),function(t){t.querySelectorAll("a:not(a.pt354_productDescription)").forEach((function(t){t.addEventListener("click",(function(t){var e,n;t.preventDefault(),d(),e=t.target.closest(".ProductItem").querySelector(".pt354_popup").cloneNode(!0),n=document.querySelector(".pt354_popupContainer"),e&&n&&(n.insertAdjacentElement("beforeend",e),n.querySelector(".pt354_imageContainer > div")&&setTimeout(u,100),n.querySelector(".pt354_addToCart_button").addEventListener("click",l),n.querySelector(".pt354_productDescription").addEventListener("click",d),r((function(){return null!==n.querySelector(".pt354_imageContainer .flickity-viewport")})).then((function(){var t=n.querySelector(".pt354_imageContainer .flickity-viewport");t&&t.addEventListener("touchstart",(function e(){a("100240418"),p("OP_PT_354","SUBS LP - Modal Image Interc.",""),t.removeEventListener("touchstart",e)}))}))),document.body.classList.contains("pt354_popupActive")||document.body.classList.add("pt354_popupActive")}))}))}(t)},fetch(s).then((function(t){return t.text()})).then((function(t){var r=(new DOMParser).parseFromString(t,"text/html");try{var o=r.querySelector(e);n(o)}catch(t){n(null,t)}})).catch((function(t){console.warn("Something went wrong.",t)}))}!function(t,e){!function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"v1";window.optiActiveTests=window.optiActiveTests||{},window.optiActiveTests[t]=e}("PT_354","v1");var n=function(t,e){return t?console.log.bind(console,"".concat(e,":")):function(){}}(!1,"PT_354");r((function(){return null!=document.querySelector(o.subCollections)&&"/pages/build-your-own-subscription"===window.location.pathname&&"function"==typeof window.jQuery})).then((function(){var t,e;n("workflow fn called"),(function(){var t,e=[],n=window.document,r=window.MutationObserver||window.WebKitMutationObserver;function o(){for(var t,r,o=0,c=e.length;o<c;o++){t=e[o];for(var i,u=0,p=(r=n.querySelectorAll(t.selector)).length;u<p;u++)(i=r[u]).ready||(i.ready=[]),i.ready[o]||(i.ready[o]=!0,t.fn.call(i,i))}}window.optiReady=function(c,i){e.push({selector:c,fn:i}),t||(t=new r(o)).observe(n.documentElement,{childList:!0,subtree:!0}),o()}}(),document.body.classList.add("pt_354"),document.body.insertAdjacentHTML("beforeend",c.productPopupWrapper),t=document.querySelector(".pt354_popupOverlay"),e=document.querySelector(".pt354_popupWrapper .pt354_closePopup_btn"),t.addEventListener("click",(function(){a("100240666"),p("OP_PT_354","SUBS LP - Close Modal",""),d()})),e.addEventListener("click",(function(){a("100240666"),p("OP_PT_354","SUBS LP - Close Modal",""),d()})),window.optiReady(o.productItem,(function(t){s(t)})))}))}()},function(t,e){},,,,function(t,e){}]);